exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-option{width:100%;display:flex;justify-content:start;align-items:center}.danger{color:var(--fts-danger)}", ""]);

// exports
